import { type Time, type ZonedDateTime } from "@internationalized/date";
import { type Dispatch, type SetStateAction } from "react";
import { type CalendarAria } from "react-aria";
import { type CalendarState } from "react-stately";

import { BookMeetingForm } from "./book-meeting-form";
import { BookMeetingTimePicker } from "./book-meeting-timepicker";
import { MeetingCalendar } from "./meeting-calendar";

export function DesktopBookMeetingContent({
  calendar,
  setTimeSlot,
  state,
  timeSlots,
  zonedDateTime,
}: {
  calendar: CalendarAria;
  state: CalendarState;
  zonedDateTime: ZonedDateTime;
  setTimeSlot: Dispatch<SetStateAction<Time>>;
  timeSlots: Time[];
}) {
  return (
    <div className="grid gap-6 md:grid-cols-3">
      <div {...calendar.calendarProps}>
        <MeetingCalendar state={state} title={calendar.title} />
      </div>
      <BookMeetingTimePicker
        value={zonedDateTime}
        setValue={setTimeSlot}
        timeSlots={timeSlots}
      />
      <BookMeetingForm zonedDateTime={zonedDateTime} />
    </div>
  );
}
